<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-row>
        <v-col cols="2">
          <v-icon @click="goBack">
            mdi-chevron-left
          </v-icon>
        </v-col>
        <v-col class="d-flex justify-space-around">
          <v-toolbar-title class="pageTitle">
            Offene Pfandrückgaben
          </v-toolbar-title>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
        </v-col>
      </v-row>
    </v-toolbar>
    <v-divider class="headerDivider"/>

    <div class="contentWrapper" style="padding-top: 20px;">
      <v-row>
        <v-col cols="12"
                v-for="(deposit, index) in savedDeposits"
                :key="index"
        >
          <v-card class="saved-deposit__list-card">
            <span>{{ parseMarketName(deposit.market) }}</span>
            <br>
            <span>Pfandartikel: {{ parseTotalDepositLength(deposit.deposit) }}</span>

            <v-btn class="marketSelectBtn"
                   @click="openSavedDepositDetails(index)"
            >
              Auswählen
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import {mapMutations} from 'vuex'
  export default {
    name: "savedDeposits",

    methods: {
      ...mapMutations({
        setHeaderVisibility: 'setHeaderVisibility'
      }),

      goBack() {
        router.go(-1)
      },

      openSavedDepositDetails(index) {
        router.push({name: 'savedDepositDetails', params: {id: index}})
      },

      parseMarketName(custNo) {
        let customers = JSON.parse(localStorage.getItem('customers'))
        let customer = customers.filter(customer => customer.customerNo === custNo)
        return customer[0].marketName
      },

      parseTotalDepositLength(deposit) {
        let keys = Object.keys(deposit)
        let count = 0
        keys.forEach(key => {
          if(key !== '79110') {
            count += parseInt(deposit[key])
          } else {
            count += deposit[key].length
          }
        })
        return count
      }
    },

    computed: {
      savedDeposits() {
        if(localStorage.getItem('savedDeposits') !== null) {
          return JSON.parse(localStorage.getItem('savedDeposits'))
        }
        else {
          return new Array()
        }
      },
    },

    created() {
      this.setHeaderVisibility(false)
    }
  }
</script>

<style>
  .saved-deposit__list-card {
    padding: 15px 30px;
    text-align: left;
    margin-bottom: 20px;
  }

</style>
